import { Outlet } from "react-router-dom";

const Assets = () => {
  return <Outlet />;
};

export default Assets;
